module.exports = function (property) {
  const streetName = property.property.street_name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .trim()
    .replace(/\s+/g, "-");
  return `/properties/${property.property.civic_number_start}-${streetName}/${property.property.mls_no}`;
};
